// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"ribbon-module--ribbon--12wKO"};